var _module_exports = "<p>\r\n    These yards list their vehicle inventory on Row52! You can search, view pictures, set-up alerts and more.\r\n</p>";;
var path = 'yards/ParticipantYard.html';
window.angular.module('row52-templates').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;